import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { Button, theme, Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';

interface SearchErrorStateProps {
  onRetry: () => void;
}

export const SearchErrorState: React.FC<SearchErrorStateProps> = ({
  onRetry,
}) => {
  const { t } = useTranslation('globalNavigation');
  const { useToken } = theme;
  const { token } = useToken();

  const handleRetry = useCallback(() => {
    onRetry();
  }, [onRetry]);

  return (
    <ErrorState data-testid="search-overlay-error-state">
      <ErrorStateTitle level={3}>
        {t('searchOverlay.errorState.title')}
      </ErrorStateTitle>
      <ErrorStateDescription style={{ color: token.colorTextSecondary }}>
        {t('searchOverlay.errorState.description')}
      </ErrorStateDescription>
      <RetryButton type="text" onClick={handleRetry}>
        {t('searchOverlay.errorState.retry')}
      </RetryButton>
    </ErrorState>
  );
};

const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 24px 48px 16px;
  text-align: center;
`;

const ErrorStateTitle = styled(Typography.Title)`
  margin: 0 0 14px;
  font-size: 18px;
  line-height: 26px;
`;

const ErrorStateDescription = styled(Typography.Paragraph)`
  max-width: 390px;
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 24px;
`;

const RetryButton = styled(Button)`
  min-height: 32px;
  padding-inline: 8px;
  font-weight: 600;
`;
